export default "__VITE_ASSET__4a094ff5__"